import { useEffect, useRef, useState, type FormEvent } from "react";
import type { ChatMessage, IntakeChoice } from "../lib/types";
import styles from "./ContractChat.module.css";

interface Props {
  messages: ChatMessage[];
  loading: boolean;
  choice: IntakeChoice | null;
  onSend: (text: string) => void;
}

export function ContractChat({ messages, loading, choice, onSend }: Props) {
  const [draft, setDraft] = useState("");
  const fimRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    fimRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, loading]);

  function submit(e: FormEvent) {
    e.preventDefault();
    const t = draft.trim();
    if (!t || loading) return;
    setDraft("");
    onSend(t);
  }

  return (
    <div className={styles.chat}>
      <div className={styles.thread}>
        {messages.map((m, i) => (
          <div key={i} className={`${styles.msg} ${m.role === "user" ? styles.user : styles.assistant}`}>
            {m.content}
          </div>
        ))}
        {loading && <div className={`${styles.msg} ${styles.assistant} ${styles.typing}`}>digitando…</div>}
        <div ref={fimRef} />
      </div>

      {choice && choice.options.length > 0 && (
        <div className={styles.choices}>
          {choice.options.map((opt) => (
            <button
              key={opt}
              className={styles.choiceBtn}
              disabled={loading}
              onClick={() => onSend(opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      )}

      <form className={styles.inputBar} onSubmit={submit}>
        <input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Digite sua resposta…"
          disabled={loading}
        />
        <button type="submit" className="btn btn-primary" disabled={loading || !draft.trim()}>
          Enviar
        </button>
      </form>
    </div>
  );
}
